import {NuxtIcon} from "#components";
import {h} from "vue";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 25 44"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("circle", {
      cx: "12.413",
      cy: "8.409",
      r: "7.409",
      stroke: "#000",
      "stroke-width": "2"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#000",
      "fill-rule": "evenodd",
      d: "M7 17.617a7 7 0 0 0-7 7v16.425a2 2 0 0 0 2 2h20.824a2 2 0 0 0 2-2V24.617a7 7 0 0 0-7-7H7Zm15.824 17.217V24.617a5 5 0 0 0-5-5H7a5 5 0 0 0-5 5v16.425h20.824v-6.208Z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]))]))
}
export default { render() { return h(NuxtIcon, {icon: {render}, name: "user"}) } }